(() => {
  const intro = document.querySelector('[data-ltp-editorial-intro]');
  const product = document.querySelector('product-info[data-ltp-editorial-pdp="true"]');
  if (!intro || !product) return;

  const header = document.querySelector('.section-header');
  const sticky = header?.querySelector('sticky-header');
  const announcements = [...document.querySelectorAll('.shopify-section-group-header-group')]
    .filter((section) => section !== header);
  const alwaysSticky = ['always', 'reduce-logo-size'].includes(sticky?.getAttribute('data-sticky-type'));
  let navigationHeight = 0;
  const updateStickySpace = () => {
    const visible = alwaysSticky || (header?.classList.contains('shopify-section-header-sticky') &&
      !header.classList.contains('shopify-section-header-hidden'));
    product.style.setProperty('--ltp-editorial-sticky-height', (visible ? navigationHeight : 0) + 'px');
  };
  const measureHeader = () => {
    navigationHeight = header?.offsetHeight || 0;
    intro.style.setProperty('--ltp-editorial-nav-height', navigationHeight + 'px');
    product.style.setProperty('--ltp-editorial-nav-height', navigationHeight + 'px');
    intro.style.setProperty('--ltp-opening-announcement', announcements.reduce((total, section) => total + section.getBoundingClientRect().height, 0) + 'px');
    updateStickySpace();
  };
  measureHeader();
  const headerObserver = new ResizeObserver(measureHeader);
  [header, ...announcements].filter(Boolean).forEach((section) => headerObserver.observe(section));
  if (header) new MutationObserver(updateStickySpace).observe(header, { attributes: true, attributeFilter: ['class'] });

  intro.querySelector('[data-ltp-editorial-shop]')?.addEventListener('click', (event) => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const mobile = window.matchMedia('(max-width: 989px)').matches;
    const target = mobile
      ? product.querySelector('variant-selects')
      : product.querySelector('.ltp-editorial-purchase');
    if (!target) return;
    event.preventDefault();
    product.querySelector('media-gallery')?.releaseEditorialOpening?.();
    const offset = mobile ? navigationHeight + 16 : (alwaysSticky ? navigationHeight : 0);
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.history.pushState(null, '', '#' + target.id);
    window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
